import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {Actions} from '../../../common/actions';

const maritimeTransportation = 'M';
const getOrderAmount = (orderList = []) => {
  return orderList.reduce((total, element) => {
    if (element.checked && element.transport !== maritimeTransportation && !!element.salesICC) {
      return total + element.totalFob;
    }
    return total;
  }, 0);
};

class LimitControl extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.generatingTxt && !this.props.generatingTxt) {
      const date = new Date();
      this.props.getProviderOrderLimit({'year': date.getFullYear()});
    }
  }

  render() {
    const {totalLimit, totalValue, detail} = this.props;
    const remainingValue = totalLimit - totalValue;
    const orderValue = getOrderAmount(detail);

    return (
      <React.Fragment>
        <div className={totalValue > totalLimit ? 'limit-error' : ''}>
          <strong>Pedidos Aéreos{'&'}VOR consumido / Cupo total: &nbsp;</strong>
          $ {getNumericValue(totalValue, 2)} / $ {getNumericValue(totalLimit, 2)}
        </div>
        <div className={orderValue > remainingValue ? 'limit-error' : ''}>
          <strong>Pedido actual Aéreo / Cupo disponible: &nbsp;</strong>
          $ {getNumericValue(orderValue, 2)} / $ {getNumericValue(remainingValue, 2)}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'totalLimit': state.providerOrdersControl.totalLimit,
    'totalValue': state.providerOrdersControl.totalValue,
    'detail': state.providerOrdersList.list,
    'transport': state.providerManualOrder.transport,
    'generatingTxt': state.providerOrdersList.generatingTxt,
  };
};

const {
  getProviderOrderLimit,
} = Actions;

export default connect(mapStateToProps, {getProviderOrderLimit})(LimitControl);
